import { Col, Row, Tag } from 'antd';
import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Reload } from 'assets/svg';
import { Button } from 'components';
import { IOrderProcess } from 'interfaces/SalesInfo';
import CustomCollapse, {
  IPanelConfig,
} from '../../components/Collapse/CustomCollapse';
import { formatDate } from 'utils/constants/functions';

interface IDocumentTabProps {
  data: {
    sap: IOrderProcess[];
    dms: IOrderProcess[];
  };
  refetch: () => void;
}

export const DocumentTab = memo(({ data, refetch }: IDocumentTabProps) => {
  const panels: IPanelConfig[] = useMemo(
    () => [
      {
        key: 'dms',
        title: 'Thông tin DMS',
        data: data.dms,
        columns: [
          { title: 'Mã DMS', dataIndex: 'orderId' },
          { title: 'Người tạo', dataIndex: ['tcreateUser', 'fullName'] },
          { title: 'Mô tả', dataIndex: ['processStatus', 'name'] },
          { title: 'Mã cha', dataIndex: 'mainCustomerId' },
          {
            title: 'Thời gian',
            dataIndex: 'createDate',
            render: (value) => (value ? formatDate(value) : '-'),
          },
          {
            title: 'Trạng thái',
            dataIndex: 'status',
            render: (status: string) => (
              <Tag
                bordered={false}
                className="!bg-transparent"
                color={status ? 'green' : 'red'}
              >
                {status ? 'Thành công' : 'Thất bại'}
              </Tag>
            ),
          },
        ],
      },
      {
        key: 'sap',
        title: 'Thông tin SAP',
        data: data.sap,
        columns: [
          { title: 'Lần gọi', dataIndex: 'callNumber' },
          { title: 'Loại chứng từ', dataIndex: ['processStatus', 'id'] },
          { title: 'Mã chứng từ', dataIndex: 'processId' },
          {
            title: 'Link/File',
            dataIndex: 'url',
            render: (link: string) => (
              <Link
                to={link}
                target="_blank"
                className="text-[#0077CC] font-bold"
              >
                {link}
              </Link>
            ),
          },
          {
            title: 'Thời gian',
            dataIndex: 'createDate',
            render: (value) => (value ? formatDate(value) : '-'),
          },
          { title: 'Mã lỗi', dataIndex: 'errorMessage' },
          {
            title: 'Trạng thái',
            dataIndex: 'status',
            render: (value: string, record: any) => {
              const status =
                !record?.errorMessage && !record.status
                  ? 'Đang chờ'
                  : value
                    ? 'Thành công'
                    : 'Thất bại';

              return (
                <Tag
                  bordered={false}
                  className="!bg-transparent"
                  color={
                    status === 'Thành công'
                      ? 'green'
                      : status === 'Đang chờ'
                        ? 'yellow'
                        : 'red'
                  }
                >
                  {status}
                </Tag>
              );
            },
          },
        ],
      },
    ],
    [data],
  );

  return (
    <>
      <Row justify="end" align={'middle'}>
        <Col>
          <Button title={<Reload />} handleOnclick={refetch} />
        </Col>
      </Row>
      <CustomCollapse panels={panels} isShowLength={false} />
    </>
  );
});
